import TimeAgo from "javascript-time-ago";
import es from "javascript-time-ago/locale/es-MX";

TimeAgo.addLocale(es);
export const timeAgo = new TimeAgo("es-MX");